export function useRequiredInject<T>(key: string) {
  const value = inject<T>(key)
  if (value === undefined) throw new Error(`${key} not injected`)
  return value
}
